"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ON_MARKSHEET_MARK_CHANGE = exports.ON_MARKSHEET_MARK_CHANGE_KEY = exports.ON_PRESTART_MARKSHEET_CHANGE = exports.ON_PRESTART_MARKSHEET_CHANGE_KEY = exports.ON_MARKSHEET_CHANGE = exports.ON_MARKSHEET_CHANGE_KEY = void 0;
const client_1 = require("@apollo/client");
exports.ON_MARKSHEET_CHANGE_KEY = 'ON_MARKSHEET_CHANGE_KEY';
exports.ON_MARKSHEET_CHANGE = (0, client_1.gql) `
  subscription OnMarksheetChange($sessionId: String!) {
    onMarksheetChange(sessionId: $sessionId) {
      marksheetId
      agoraId
      sessionId
      userId
      user {
        id
        displayName
      }
      users {
        id
        displayName
      }
      activeUsers {
        id
        displayName
      }
      startedAt
      endedAt
      state
      action
    }
  }
`;
exports.ON_PRESTART_MARKSHEET_CHANGE_KEY = 'ON_PRESTART_MARKSHEET_CHANGE_KEY';
exports.ON_PRESTART_MARKSHEET_CHANGE = (0, client_1.gql) `
  subscription OnPreStartMarksheetChange($sessionId: String!) {
    onPreStartMarksheetChange(sessionId: $sessionId) {
      marksheetId
      sessionId
      topicConceptData
      action
      user {
        id
        displayName
      }
      preBuildData {
        buildRef
        seenCorrect
        seenIncorrect
        unseen
      }
      builderConfig {
        difficulty
        isTest
        numberOfQuestions
        secondsPerQuestion
        unseen
        seenCorrect
        seenIncorrect
      }
    }
  }
`;
exports.ON_MARKSHEET_MARK_CHANGE_KEY = 'ON_MARKSHEET_CHANGE_KEY';
exports.ON_MARKSHEET_MARK_CHANGE = (0, client_1.gql) `
  subscription OnMarksheetMarkChange($sessionId: String!) {
    onMarksheetMarkChange(sessionId: $sessionId) {
      action
      marksheetId
      sessionId
      markId
      newMarkId
      markIndex
      questionChoiceId
      mark
      isAnswered
      timeTaken
      updatedAt
      user {
        id
        displayName
      }
      striked
    }
  }
`;
